// extracted by mini-css-extract-plugin
export default {"train":"Train_train__DJyWi","layout":"Train_layout__knwSN"};